<template>
<div>
    <div class="cstm_card_header cstm_dashboard_card px-4 py-2">
      <h4 style="font-weight: 500;" v-if="stats">Module: {{ stats.module_name }}</h4>
      <vs-dropdown>
        <vs-button class="btn-drop" type="flat" icon="more_vert"></vs-button>
        <vs-dropdown-menu>
          <vs-dropdown-item @click="beginEdit()">
            Edit
          </vs-dropdown-item>
          <vs-dropdown-item @click="openConfirm()">
            Delete
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <statistics-card-line
      hideChart
      class="h-full"
      :module_name="stats.module_name"
      :icon="stats.module_icon"
      icon-right
      :statistic="stats.count"
      :statisticTitle="analytics.name"
    />
</div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
export default {
  name: 'Stat-Card',
  props: ['cardId', 'analytics', 'stats'],
  components: {
    StatisticsCardLine
  },
  methods: {
    openConfirm () {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Delete Card',
        text: 'Are you sure you want to delete this card?',
        accept: this.onDelete
      })
    },
    onDelete () {
      this.$emit('card-delete', this.cardId)
    },
    beginEdit () {
      this.$emit('card-edit', { card_id: this.cardId, widget_type: 'stat', data: { analytics: {...this.analytics}, stats: {...this.stats} } })
    }
  }
}
</script>